export default {
    getAnimal: state => (animalId) => state.animals.find((animal) => animal.id === animalId),
}
